<template>
  <Form ref="officeEquipmentForm" :model="officeEquipment" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="officeEquipment.id" type="hidden"/>

    <FormItem  :label="this.$t('property.office-equipment.equipmentNo.label')" prop="equipmentNo">
      <Input v-model="officeEquipment.equipmentNo" :placeholder="$t('property.office-equipment.equipmentNo.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('property.office-equipment.type.label')" prop="type">
      <Select v-model="officeEquipment.type" :placeholder="$t('property.office-equipment.type.holder')" filterable>
        <Option v-for="item in this.dict.deviceType" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('property.office-equipment.remark.label')" prop="remark">
      <Input v-model="officeEquipment.remark" :placeholder="$t('property.office-equipment.remark.holder')"/>
    </FormItem>

    <div v-if="actionType=='detail'">
      <FormItem  :label="this.$t('property.office-equipment.createTime.label')" prop="createTime">
        <Date-picker v-model="officeEquipment.createTime" type="datetime"  :placeholder="this.$t('property.office-equipment.createTime.holder')"></Date-picker>
      </FormItem>
    </div>
    <!--<FormItem  :label="this.$t('property.office-equipment.isDelete.label')" prop="isDelete">
      <InputNumber v-model="officeEquipment.isDelete" :placeholder="$t('property.office-equipment.isDelete.holder')"/>
    </FormItem>-->

  </Form>
</template>
<script>
import api from '@/api'

export default {
  dictParams: ['deviceType'],
  data () {
    return {
      officeEquipment: {
        id: null,
        equipmentNo: null,
        type: null,
        remark: null,
        createTime:null
      },
      animal: '电脑',
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['officeEquipmentForm'].validate(valid => {
        if (valid) {
          if (this.officeEquipment.id) {
            this.updateOfficeEquipment(this.officeEquipment).then(then).error(error)
          } else {
            this.createOfficeEquipment(this.officeEquipment).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.officeEquipment.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['officeEquipmentForm'].resetFields());
    },
    getOfficeEquipment(id,type){
      this.loading = true;
      this.$refs['officeEquipmentForm'].resetFields()
      api.property.OfficeEquipment.detail(id).then(data => {
        this.officeEquipment = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createOfficeEquipment(officeEquipment){
      this.loading = true;
      return api.property.OfficeEquipment.add(officeEquipment)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateOfficeEquipment(officeEquipment){
      this.loading = true;
      return api.property.OfficeEquipment.update(officeEquipment)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      equipmentNo: [{type: 'string', required: true, message: this.$t('property.office-equipment.equipmentNo.required'),trigger: 'blur'}, {type: 'string',max: 80, message: this.$t('property.office-equipment.equipmentNo.max'),trigger: 'blur'}],
      type: [{type: 'number', required: true, message: this.$t('property.office-equipment.type.required'),trigger: 'blur'}],
      remark: [{type: 'string',max: 255, message: this.$t('property.office-equipment.remark.max'),trigger: 'blur'}],
      createTime: [{type: 'date', required: true, message: this.$t('property.office-equipment.createTime.required'),trigger: 'blur'}],
     /* updateTime: [{type: 'date', required: true, message: this.$t('property.office-equipment.updateTime.required'),trigger: 'blur'}],
      isDelete: [{type: 'number', required: true, message: this.$t('property.office-equipment.isDelete.required'),trigger: 'blur'}]*/
      }
      if(this.actionType == 'edit'){
        this.$refs['officeEquipmentForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
